import { type TipoComunicazioneDTO } from '@framework/api-client/api/inquiries-compile/schemas/tipoComunicazioneDTO.ts';
import { useWatch } from 'react-hook-form';

/**
 * Hook che ritorna il tipo comunicazione attualmente selezionato
 * nel drawer di configurazione di una comunicazione
 */
export function useSelectedCommunicationType():
  | TipoComunicazioneDTO
  | null
  | undefined {
  const value = useWatch({ name: 'communicationType' }) as
    | TipoComunicazioneDTO
    | undefined
    | null;

  return value;
}
